import React, {
  createContext, useContext, useState,
} from 'react';
import PropTypes from 'prop-types';

const initialValue = {
  sidebarIsOpen: false,
  activePages: [],
  notification: false,
};

const PageMaskContext = createContext(initialValue);

export function PageMaskContextProvider({ children, availablePages }) {
  const [pageMaskState, setPageMaskState] = useState(initialValue);

  function handleSidebarEvent() {
    setPageMaskState((prevState) => ({
      ...prevState,
      sidebarIsOpen: !prevState.sidebarIsOpen,
    }));
  }

  function handleNotificationEvent() {
    setPageMaskState((prevState) => ({
      ...prevState,
      notification: !prevState.notification,
    }));
  }

  const contextValue = {
    pageMaskState,
    setPageMaskState,
    handleSidebarEvent,
    handleNotificationEvent,
    availablePages,
  };

  return (
    <PageMaskContext.Provider value={contextValue}>
      {children}
    </PageMaskContext.Provider>
  );
}

export function usePageMaskContext() {
  return useContext(PageMaskContext);
}

PageMaskContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  availablePages: PropTypes.arrayOf(PropTypes.object),
};

PageMaskContextProvider.defaultProps = {
  availablePages: [{}],
};
